// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8496eed4","238":"8febbcc4","239":"36c3f3bc","450":"c9588c29","453":"6c4e9e1f","455":"25e13a67"}[chunkId] + ".chunk.js";
};